import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faLaptop } from '@fortawesome/pro-solid-svg-icons';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';

export default function AddedBy({ lead }) {
  const { source, referralSourceLabel, referralSourceIcon, user } = lead;

  let icon, tooltipText;

  // Use dynamic partner favicon if available
  if (referralSourceIcon) {
    tooltipText = referralSourceLabel;
    icon = <span className="avatar avatar-lg"><img className="img-avatar" src={referralSourceIcon} /></span>;
  } else if (source === 'connect') {
    tooltipText = 'Connect';
    icon = <span className="fa-stack fa-lg align-middle" name="web-activity">
      <FontAwesomeIcon className="fa-stack-2x icon-purple" icon={faCircle} />
      <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faBuildoutLogo} />
    </span>;
  } else if (source === 'web_activity') {
    tooltipText = 'Web Activity';
    icon = <span className="fa-stack fa-lg align-middle" name="web-activity">
      <FontAwesomeIcon className="fa-stack-2x text-primary" icon={faCircle} />
      <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faLaptop} />
    </span>;
  } else {
    tooltipText = user.name;
    icon = (
      <img className="img-avatar avatar avatar-lg" src={user.imageUrl} />
    );
  }

  const tooltip = <Tooltip id={`added-by-${lead.id}`}>{tooltipText}</Tooltip>;
  return (
    <div className="text-center">
      <OverlayTrigger overlay={tooltip} placement="top">{icon}</OverlayTrigger>
    </div>
  );
}

AddedBy.propTypes = {
  lead: PropTypes.shape({
    referralSourceLabel: PropTypes.string,
    referralSourceIcon: PropTypes.string,
    source: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired
    })
  }).isRequired
};
